export default __webpack_public_path__ + "static/media/cr2.c1838512.png";